export const setMenuMinimizedState = (state, boolean) => {
  state.isMenuMinimized = boolean
}
